import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.mixin({
  methods: {
    uiAlert (message, title = '提示', options = {}) {
      const msg = String(message || '')
      return this.$alert(msg, title, {
        confirmButtonText: '确定',
        customClass: 'messagebox-themed',
        ...options
      })
    },
    uiConfirm (message, title = '提示', options = {}) {
      const msg = String(message || '')
      return this.$confirm(msg, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'messagebox-themed',
        ...options
      }).then(() => true).catch(() => false)
    },
    uiPrompt (message, title = '请输入', options = {}) {
      const msg = String(message || '')
      return this.$prompt(msg, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'messagebox-themed',
        ...options
      }).then(res => (res && typeof res === 'object' ? res.value : '')).catch(() => null)
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
